import { render, staticRenderFns } from "./GtdjJbxx.vue?vue&type=template&id=06c31fed&scoped=true"
import script from "./GtdjJbxx.vue?vue&type=script&lang=js"
export * from "./GtdjJbxx.vue?vue&type=script&lang=js"
import style0 from "./GtdjJbxx.vue?vue&type=style&index=0&id=06c31fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c31fed",
  null
  
)

export default component.exports